import React from 'react';
import '../styles/Legal.css';
import usePageMeta from "../hooks/usePageMeta";

const LAST_UPDATED = 'January 9, 2026';

const SecurityPage: React.FC = () => {
  usePageMeta({
    title: "Security | PabSync",
    description:
      "Security practices and features that help protect your PabSync account and data.",
    path: "/security",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Security</h1>
          <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

          <p>
            PabSync is designed with security in mind. This page summarizes security practices and features that help
            protect accounts and data.
          </p>

          <h2>What we do</h2>
          <ul>
            <li>Use HTTPS to encrypt data in transit.</li>
            <li>Use access controls to restrict internal access to systems and data.</li>
            <li>Monitor for suspicious activity and abuse.</li>
            <li>Maintain backups and operational safeguards.</li>
          </ul>

          <h2>What you can do</h2>
          <ul>
            <li>Use a strong, unique password and enable any available security settings.</li>
            <li>Be careful with shared links, third-party integrations, and browser extensions.</li>
            <li>Report suspicious activity promptly.</li>
          </ul>

          <h2>Related pages</h2>
          <p>
            See our <a href="/privacy">Privacy Statement</a> and <a href="/cookies">Cookies Notice</a>.
          </p>

          <h2>Contact</h2>
          <p>
            For security concerns, use <a href="/contact">Contact</a>.
          </p>

          <p className="legal-note">
            This page is provided for general informational purposes and may be updated from time to time.
          </p>
        </article>
      </main>
    </div>
  );
};

export default SecurityPage;
